/**
 * Filter Rebuild Hook — buttonsbebe.com
 * ---------------------------------------
 * Both the Size and Brand/Vendor custom filter scripts need to rebuild
 * their UI every time the theme's own Collection.init() runs — which
 * happens once on initial page load AND after every subsequent AJAX
 * filter update (per sections/main-collection-product-grid.liquid and
 * assets/storefont-filters.js).
 *
 * IMPORTANT: Collection's init is defined as a class field arrow function
 * (`init = () => {...}`), which means it's created as an OWN PROPERTY of
 * each INSTANCE (assigned in the constructor), NOT as a method on
 * Collection.prototype. So we have to wait for the actual instance
 * (window.MinimogTheme.Collection) to exist and patch its init directly —
 * patching the prototype (what an earlier version of this file tried)
 * silently does nothing for this class.
 */
(function () {
  'use strict';

  window.__customFilterRebuilders = window.__customFilterRebuilders || [];

  function tryPatch() {
    if (!window.MinimogTheme || !window.MinimogTheme.Collection || typeof window.MinimogTheme.Collection.init !== 'function') {
      return false;
    }
    if (window.MinimogTheme.Collection.__filterHookPatched) return true;

    var originalInit = window.MinimogTheme.Collection.init;
    window.MinimogTheme.Collection.init = function () {
      var result = originalInit.apply(window.MinimogTheme.Collection, arguments);
      window.__customFilterRebuilders.forEach(function (fn) {
        try {
          fn();
        } catch (e) {
          console.error('[Filter rebuild hook]', e);
        }
      });
      return result;
    };
    window.MinimogTheme.Collection.__filterHookPatched = true;
    return true;
  }

  function tryPatchAccordions() {
    if (!window.MinimogTheme || !window.MinimogTheme.Collection || typeof window.MinimogTheme.Collection.initAccordions !== 'function') {
      return false;
    }
    if (window.MinimogTheme.Collection.__accordionHookPatched) return true;

    // The theme's Accordion class, when presetContentHeight is true (which
    // initAccordions enables for the persistent "leftColumn" sidebar layout),
    // measures scrollHeight for EVERY open filter widget on every single
    // filter change — a forced reflow per widget, confirmed via a Performance
    // recording as a real, measured cause of the reported vibration. We don't
    // need the smooth exact-height transition this enables (our own Size and
    // Brand/Vendor widgets already force their own height directly), so we
    // disable it here rather than editing the theme's own file.
    var originalInitAccordions = window.MinimogTheme.Collection.initAccordions;
    window.MinimogTheme.Collection.initAccordions = function () {
      var domNodes = this.domNodes;
      var filtersWrapper = domNodes && domNodes.filtersWrapper;
      if (this.accordions && this.accordions.destroy) this.accordions.destroy();
      if (filtersWrapper) filtersWrapper.classList.remove('acc-initialized');
      if (filtersWrapper && window.MinimogLibs && window.MinimogLibs.Accordion) {
        this.accordions = new window.MinimogLibs.Accordion(filtersWrapper, {
          presetContentHeight: false,
          callback: function () {
            filtersWrapper.style.setProperty('opacity', '1');
          }
        });
      } else {
        originalInitAccordions.apply(this, arguments);
      }
    };
    window.MinimogTheme.Collection.__accordionHookPatched = true;
    return true;
  }

  function tryPatchScrollToTop() {
    var filtersForm = document.querySelector('collection-filters-form');
    if (!filtersForm || typeof filtersForm.scrollToTop !== 'function') return false;
    if (filtersForm.__scrollHookPatched) return true;

    // scrollToTop is a class field arrow function (instance property), same
    // pattern as Collection's init/initAccordions — defined per-instance,
    // not on the prototype. Overriding it with a no-op keeps every other
    // part of the filter flow (fetch, DOM replace, re-init) working exactly
    // as before, it just skips the forced scroll back to the product grid.
    filtersForm.scrollToTop = function () {};
    filtersForm.__scrollHookPatched = true;
    return true;
  }

  var patch1Done = tryPatch();
  var patch2Done = tryPatchAccordions();
  var patch3Done = tryPatchScrollToTop();

  if (!patch1Done || !patch2Done || !patch3Done) {
    // The instance is created inside a window 'load' listener in the theme's
    // own code, so it may not exist yet when this script first runs. Retry
    // until all patches succeed (one-time setup, not an ongoing reactive
    // mechanism).
    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      if (!patch1Done) patch1Done = tryPatch();
      if (!patch2Done) patch2Done = tryPatchAccordions();
      if (!patch3Done) patch3Done = tryPatchScrollToTop();
      if ((patch1Done && patch2Done && patch3Done) || attempts > 50) clearInterval(interval);
    }, 100);
  }
})();